import { Button, Result, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { DIT_LOGO_ALT, DIT_LOGO_URL } from "../lib/dit";

const { Paragraph, Text } = Typography;

export default function RequestAccess() {
  const navigate = useNavigate();
  const { user, signOutUser } = useAuth();

  const handleSignOut = async () => {
    await signOutUser();
    navigate("/signin", { replace: true });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "48px 16px" }}>
      <img src={DIT_LOGO_URL} alt={DIT_LOGO_ALT} style={{ height: 64, marginBottom: 24 }} />
      <Result
        status="403"
        title="Access pending"
        subTitle={
          <>
            <Paragraph>
              Your account <Text strong>{user?.email ?? "(unknown)"}</Text> is signed in, but it isn&apos;t on the OAIP team allowlist yet.
            </Paragraph>
            <Paragraph>
              Email <a href="mailto:NCDITAIandPolicy@nc.gov">NCDITAIandPolicy@nc.gov</a> to request access. An OAIP admin will add you and you can sign in again.
            </Paragraph>
          </>
        }
        extra={
          <Button type="primary" onClick={handleSignOut}>
            Sign out
          </Button>
        }
      />
    </div>
  );
}
